module.exports = __webpack_public_path__ + "img/mastercard.1afb526f.png";